import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { isMsalSilentRedirectContext } from './app/core/auth/browser-context';

if (!isMsalSilentRedirectContext(window, window.parent, window.opener, window.location.hash)) {
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
}
